import script from "./StandingMolecule.vue?vue&type=script&setup=true&lang=js"
export * from "./StandingMolecule.vue?vue&type=script&setup=true&lang=js"

import "./StandingMolecule.vue?vue&type=style&index=0&id=6025ec8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6025ec8c"]])

export default __exports__